import { useCallback, useEffect, useState } from "react";
import { getAgenda } from "../Api/ApiAgenda";

const EVENTO_CAMBIO_AGENDA = "agenda:cambio";

// Avisa a todas las instancias de useAgenda (página y campana del encabezado)
// que la agenda cambió, para que se recarguen juntas.
export const notificarCambioAgenda = () => window.dispatchEvent(new Event(EVENTO_CAMBIO_AGENDA));

// Carga la agenda personal del usuario de la sesión.
const useAgenda = () => {
  const [compromisos, setCompromisos] = useState([]);
  const [cargando, setCargando] = useState(true);

  const recargar = useCallback(async () => {
    setCargando(true);
    try {
      setCompromisos(await getAgenda());
    } catch (error) {
      console.error(error);
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => {
    recargar();
    window.addEventListener(EVENTO_CAMBIO_AGENDA, recargar);
    return () => window.removeEventListener(EVENTO_CAMBIO_AGENDA, recargar);
  }, [recargar]);

  return { compromisos, cargando, recargar };
};

export default useAgenda;
